module.exports = __webpack_public_path__ + "media/images/lig/uxu-gallery/gallery-item-4-092689fb288b1dee4ad9da3a2eb814b7.jpg";